module.exports = __webpack_public_path__ + "img/408688026.37002772.jpg";